<template>
    <div>
      <Bestsell_all/>
    </div>
  </template>
  
  <script>
  import Bestsell_all from "@/components/adminArin/pos_system/warehouse/warehouse_all/Bestsell_all";
  export default {
    name: "Bestsellall",
    components: {
      Bestsell_all
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  